import React from 'react';
import PropTypes from 'prop-types';
import { Button, Textarea } from 'module-tsl-ui-elements';
import EnhancedCheckbox from './EnhancedCheckbox';

var Agreement = function Agreement(_ref) {
  var generalTerms = _ref.generalTerms,
      additionalTerms = _ref.additionalTerms,
      stripeConnectAgreement = _ref.stripeConnectAgreement,
      onPrevious = _ref.onPrevious,
      submitText = _ref.submitText,
      resultText = _ref.resultText,
      isSubmitting = _ref.isSubmitting;
  return /*#__PURE__*/React.createElement("section", {
    className: "padding-md"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium margin-bottom-md"
  }, "General Terms and Conditions"), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(Textarea, {
    id: "generalTerms",
    defaultValue: generalTerms,
    rows: "7",
    disabled: true
  })), /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium margin-bottom-md"
  }, "Additional Terms"), /*#__PURE__*/React.createElement("div", {
    className: "margin-bottom-md"
  }, /*#__PURE__*/React.createElement(Textarea, {
    id: "additionalTerms",
    defaultValue: additionalTerms,
    rows: "7",
    disabled: true
  })), /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium margin-bottom-md"
  }, "Stripe Connected Account Agreement"), /*#__PURE__*/React.createElement("div", {
    className: "margin-bottom-md"
  }, /*#__PURE__*/React.createElement(Textarea, {
    id: "stripeConnectAgreement",
    defaultValue: stripeConnectAgreement,
    rows: "7",
    disabled: true
  })), /*#__PURE__*/React.createElement(EnhancedCheckbox, {
    caption: "I have read and I accept the agreements above",
    name: "agreements",
    size: "lg"
  }), /*#__PURE__*/React.createElement("footer", {
    className: "padding-top-ml"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    className: "seller-info-modal__cta",
    onClick: onPrevious
  }, "Back"), /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    className: "seller-info-modal__cta",
    loading: isSubmitting
  }, submitText), resultText && /*#__PURE__*/React.createElement("p", null, resultText)));
};

Agreement.displayName = "Agreement";
Agreement.propTypes = {
  generalTerms: PropTypes.string.isRequired,
  additionalTerms: PropTypes.string.isRequired,
  stripeConnectAgreement: PropTypes.string.isRequired,
  onPrevious: PropTypes.func.isRequired,
  submitText: PropTypes.string,
  resultText: PropTypes.string,
  isSubmitting: PropTypes.bool
};
export default Agreement;